<template>
  <div class="swiper-container swiperSec2">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-bind:key="item.index" v-for="item in imgs">
        <div class="container">
          <div>
            <img alt="xxx" :src="item.url" style="width: 100%;" />
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-button-prev swiper-button-left"></div>
    <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
    <div class="swiper-button-next swiper-button-right"></div>
  </div>
</template>
<script>
import Swiper from "./js/swiper.min.js";
export default {
  props: ["imgs", "index"],
  name: "Swiper",
  data() {
    return {};
  },
  methods: {
    initSwiper() {
      const swip = new Swiper(".swiperSec2", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
        loop: true,
        initialSlide: parseInt(this.index),
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  },
  created() {},
  mounted() {
    this.initSwiper();
  },
};
</script>
<style scoped>
@import url("./css/swiper.min.css");
.swiper-button-left {
  --swiper-navigation-size: 0px; /* 设置按钮大小 */
  width: 20px;
  height: 30px;
  padding: 2px;
  background-image: url("../../../assets/imgs/left-white.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.swiper-button-right {
  --swiper-navigation-size: 0px; /* 设置按钮大小 */
  width: 20px;
  height: 30px;
  padding: 2px;
  background-image: url("../../../assets/imgs/right-white.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.swiper-container {
  position: relative;
  width: 100%;
}
.container {
  position: relative;
  width: 100%;
}
</style>
